module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Williams_The_Election_of_Grace_text_CC3#toc2"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTOCAnchor-1"
    }
  }), _vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("Out of the depths I cry to you, O L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _vm._v(";"), _c('br'), _vm._v("\tO Lord, hear my voice."), _c('br'), _vm._v("Let your ears be attentive"), _c('br'), _vm._v("\tto my cry for mercy."), _c('br'), _vm._v("If you, O L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _vm._v(", kept a record of sins,"), _c('br'), _vm._v("\tO Lord, who could stand?"), _c('br'), _vm._v("But with you there is forgiveness;"), _c('br'), _vm._v("\ttherefore you are feared."), _c('br'), _vm._v("I wait for the L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _vm._v(", my soul waits,"), _c('br'), _vm._v("\tand in his word I put my hope."), _c('br'), _vm._v("My soul waits for the Lord"), _c('br'), _vm._v("\tmore than watchmen wait for the morning,"), _c('br'), _vm._v("\tmore than watchmen wait for the morning."), _c('br'), _vm._v("O Israel, put your hope in the L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _vm._v(","), _c('br'), _vm._v("\tfor with the L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _vm._v(" is unfailing love"), _c('br'), _vm._v("\tand with him is full redemption."), _c('br'), _vm._v("He himself will redeem Israel"), _c('br'), _vm._v("\tfrom all their sins.")]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Psalm 130"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-1",
      "id": "footnote-1257-1-backlink"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "CP"
  }, [_vm._v("My heart is not proud, O L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _vm._v(","), _c('br'), _vm._v("\tmy eyes are not haughty;"), _c('br'), _vm._v("I do not concern myself with great matters"), _c('br'), _vm._v("\tor things too wonderful for me."), _c('br'), _vm._v("But I have stilled and quieted my soul;"), _c('br'), _vm._v("\tlike a weaned child with its mother,"), _c('br'), _vm._v("like a weaned child is my soul within me."), _c('br'), _vm._v("O Israel, put your hope in the L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ord")]), _c('br'), _vm._v("\tboth now and forevermore.")]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Psalm 131")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH-L2"
  }, [_vm._v("These two juxtaposed psalms serve better than any other two juxtaposed psalms to set the tone for the following brief sortie into the doctrine of election. The first instructs the heart, preparing us for inquiry in the mode of sinners who, discerning their sin, crying out from the depths and believing that God answers them in mercy, contemplate election with the eyes of forgiven and undeserving transgressors. The second instructs the mind, preparing us for inquiry in the mode of creatures whose minds’ eye should not be trained too high, not because there is darkness above, but because what it seeks to see lies beyond its perceptual field, in the realm of things “too wonderful for me.” Psalm 130 bids those who despair of their sin to wait; Psalm 131 bids those who despair of their ignorance to be at peace. Both conduce to hope and both conclude with the thought of a future in the hands of the God whom to know is to trust. In Scripture, the climactic future is a time of definitive "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apocalypsis, ")]), _vm._v("“unveiling.” We shall find reason to suppose that this applies to the truth about election.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Meanwhile, pending eschatological disclosure, is election a riddle without a resolution? To ask that question at the beginning of an investigation is to risk starting at the wrong end. If we start at the wrong end, we are liable to finish at the wrong end, perhaps finishing more or less where we started; start with a riddle, without justifying the starting point, and you will likely end either with an unproductive riddle or with the wrong answer. “Only he is an artist who can make a riddle out of the solution,” observed Karl Kraus, tempting us to echo with rueful cynicism that only he is a theologian who can turn a solution into a riddle."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-2",
      "id": "footnote-1257-2-backlink"
    }
  }, [_vm._v("2")])]), _vm._v(" Karl Barth must be permitted an early intervention to voice his claim that election is the sum of the gospel."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-3",
      "id": "footnote-1257-3-backlink"
    }
  }, [_vm._v("3")])]), _vm._v(" Hovering somewhere between talk of riddle and of gospel is Gabriel Marcel’s distinction between a mystery and a problem."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-4",
      "id": "footnote-1257-4-backlink"
    }
  }, [_vm._v("4")])]), _vm._v(" Without prejudice to talk either of riddle or of gospel, we might provisionally admit at the outset that election enshrines mystery of some kind and to some degree.")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("Oh, the depth of the riches of the wisdom and knowledge of God!")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("\tHow unsearchable his judgments,")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("\tand his paths beyond tracing out!")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("“Who has known the mind of the Lord?")]), _vm._v(" "), _c('p', {
    staticClass: "PL"
  }, [_vm._v("\tOr who has been his counselor?” (Rom. 11:33-34)")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("That is how Paul concludes a sustained treatment of election, and we can scarcely be faulted if we treat his rhetorical climax as our theological a priori. Admitting that it is risky to start out on our investigation with a knapsack purpose-­woven in the shape of a question mark and suspending decision on election as the sum of the gospel, we submit that Paul’s words supply us with prima facie support for the supposition that election may turn out to be a question whose answer, if it is ever attained, will be eschatological, and brook no premature theological anticipation. It remains to be seen whether or not it should be reckoned something of a riddle until then.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In tackling election, it looks as though we are tackling a peculiarly intractable issue amidst the host of other historically divisive and intractable issues in theology. At the beginning of his study, Paul Jewett observed that “there is . . . something uncommonly persistent about the argument over election.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-5",
      "id": "footnote-1257-5-backlink"
    }
  }, [_vm._v("5")])]), _vm._v(" An earlier twentieth-­century voice, granting that “the treatment of any doctrine harbors its dangers, and caution is always necessary,” proposed that warning was especially in order with respect to the doctrine of election."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-6",
      "id": "footnote-1257-6-backlink"
    }
  }, [_vm._v("6")])]), _vm._v(" Although it is worth asking why this is so, if it is so, I shall not be doing so directly in this volume. Chaucer would doubtless have concluded that third-­millennium determination to pursue our chosen quarry is a sign that theologians are even more hopelessly incorrigible than are philosophers in their search for the stone that turneth all to gold. “Ask any scholar of discerning; / He’ll say the Schools are filled with altercation / On this vexed matter of predestination / Long bandied by a hundred thousand men. How can I sift it to the bottom then?”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-7",
      "id": "footnote-1257-7-backlink"
    }
  }, [_vm._v("7")])]), _vm._v(" Better not try to sift it nor even to provoke an early quarrel about the casual elision of “election” and “predestination,” unless you have nothing else to do on the road to Canterbury.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T2"
  }, [_vm._v("Given the longevity and perdurability of the debate, what can we reasonably hope to achieve in yet another inquiry? Is there not something bordering on the tragicomical in the supposition that someone should aspire to say something fresh, helpful, and illuminating on this subject, certainly in public? “Ambition is the death of thought.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-8",
      "id": "footnote-1257-8-backlink"
    }
  }, [_vm._v("8")])]), _vm._v(" Nonetheless, two associated factors informed the attempt to investigate the doctrine of election which here sees the light of day. The first was the suspicion that the unresolved persistence of the relevant cluster of questions, particularly when Scripture was regularly used as a court of appeal on opposing sides, was due to the fact that there was something wrong with the way the whole problematic was set up. Struggling to come to terms with her theological background, Harriet Beecher Stowe exclaimed: “There must be a dreadful mistake somewhere,” and, working through her struggles, her renewed verdict was unchanged: “There must be a dreadful mistake somewhere.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-9",
      "id": "footnote-1257-9-backlink"
    }
  }, [_vm._v("9")])]), _vm._v(" Perhaps “dreadful” is too dramatic a descriptor to apply in the present case, but dispassionate scrutiny of the debate on election surely compels the theologian to keep an open mind as to whether Stowe’s sentiment has potential for transplantation.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The second factor was a perceived need to consider seriously the diagnosis of and remedy for the deadlocked condition of the Calvinist-­Arminian debate which Charles Simeon offered early in the nineteenth century, and to bring this into line with a fundamental and familiar proposal made by Ludwig Wittgenstein. For reasons which emerge at the end of this volume, it turns out that Simeon features more visibly in the following discussion than does Wittgenstein. If, in the course of this volume, I succeed in making Simeon’s proposals lively, I (truly!) shall not ask for much more."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-10",
      "id": "footnote-1257-10-backlink"
    }
  }, [_vm._v("10")])]), _vm._v(" If reference to the Calvinist-­Arminian debate provokes a weary sigh or audible groan in the reader, it is more than understandable; not only can I sympathize, I can join. How can such a (portended) focus be justified in the post-­Barthian dogmatic times in which we live? More importantly, even if we decide that Barth has not successfully or satisfactorily advanced the discussion very much, is it right to sail by Christopher Wright’s warning in his valuable and detailed study "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mission of God")]), _vm._v("? “Between election in the Hebrew Scriptures of Jesus and election in the formulations of theological systems there sometimes seems to be a great gulf fixed. Few and narrow are the bridges from one to the other.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-11",
      "id": "footnote-1257-11-backlink"
    }
  }, [_vm._v("11")])]), _vm._v(" Well, our study begins with the Old Testament and ends with an appendix on Barth. I hope that, by the time we are through with a survey of the biblical materials, it will be clear why Simeon’s concerns remain ours. In recent conversation, two leading biblical scholars, theologians of fine quality, to boot, who believe in the need for dogmatic reorientation on the question of election, have expressed to me perplexity in connection with New Testament predestination. As a matter of fact, my interest in Simeon lies more in connection with theological method in general than in his specific involvement in the Calvinist-­Arminian debate, although these two things are inseparable in his thought and that particular debate was the occasion of his remarks and even contributed causally to his thinking on method.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("I prelude the following piece in the key of lament and hereby post the wailing proposition that the systematic theologian is the least secure of all creatures operating within the subject-­domain called “theology,” or, if not insecure, a creature who has purchased his or her security at the price of avoidance. He — let me keep the masculine pronoun as a concession to those who will wonder if the following is simply self-­absorbed and self-­referential — cannot give his time to and may lack the competence for the detailed study and exegesis of Old and New Testaments on whose foundation he seeks to build. He cannot give his time to and may lack the competence for the detailed philosophical adumbration of logical argument whose rigor he seeks to incorporate. Historians shake their heads at his lack of learning; missiologists and practical theologians wait skeptically to see if anything relevant will emerge; radicals and postmoderns will not even bother to watch his antics nine-­tenths of the time, save with the semicurious gaze of the cultural anthropologist. Has any creature comparable to the dogmatic or systematic theologian ever appeared on planet earth — the only character on the scholarly scene who manifestly lacks the competence to fulfill his or her assigned responsibility, the devil’s walking parody on all two-­footed things?"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-12",
      "id": "footnote-1257-12-backlink"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The following chapters will give ample cause for readers to conclude that their author is a fully signed-­up member of this sorry troupe. On the one hand, Scripture is my authority and exegesis my guide in what follows, but I shall not be able to devote proper attention to any one biblical text. On the other, the rigorous requirements of analytic philosophical argument cannot be met in the space at my disposal. Hence, reasons for reading Scripture in one way rather than another will be indicated without offering a detailed defense, and reasons for adopting one theological position rather than another will be indicated without providing a detailed demonstration. Treatment of historical theology will be amazingly thin, and the distribution of material in practical theology will be gloriously uneven. What, then, remains in the shrunken effort that follows, except evidence that the writer needs to get out a bit more? Perhaps that fine novelist and observer of humanity, Thomas Hardy, will help to preserve authorial dignity: “Limitation, and not comprehensiveness, is needed for striking a blow.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-13",
      "id": "footnote-1257-13-backlink"
    }
  }, [_vm._v("13")])]), _vm._v(" Or there is Leibniz: “It is in limitation that the master primarily displays himself.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-14",
      "id": "footnote-1257-14-backlink"
    }
  }, [_vm._v("14")])]), _vm._v(" It is better to resist such specious defenses and pretentious descriptions of what follows and simply say that this book constitutes an attempt to limn — and no more than that — a theological approach to election in stark dogmatic outline. As Austin Farrer put it in a volume which covers material relevant to my concerns, but is omitted from my discussion: “I would rather, if I dared to hope it, provide materials for an exercise in understanding, than formalize a chain of argument.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-15",
      "id": "footnote-1257-15-backlink"
    }
  }, [_vm._v("15")])]), _vm._v(" Philip Doddridge bequeaths to us a rubric for the whole study: “If I err, I would choose to do it on the side of modesty and caution, as one who is more afraid of doing wrong than of not doing right.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-16",
      "id": "footnote-1257-16-backlink"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In short, constraints of space mean that no pretense is made of justifying everything for which I contend; what the reader will encounter is often more the description than the adumbration of a particular argument; theological assumptions or disclaimers as to the possibility of pursuing this or that trail powder the ensuing treatment. Were it not for human nature, these assurances should make for a mighty relaxed company of readers. Such a company should settle down tranquilly in the conviction that it need feel not the least pressure to change its position on anything, on the grounds that my essay makes no pretense to producing the arguments needed to secure its conclusions.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("However, we should not expect the dove of peace to descend amongst us. If we confine ourselves, for a moment, to self-­styled evangelical North American exchanges, we note how sharp the conflict is in relation to the doctrine of election "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(inter alia). ")]), _vm._v("Some years ago, five contributors, adopting different positions, debated election."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-17",
      "id": "footnote-1257-17-backlink"
    }
  }, [_vm._v("17")])]), _vm._v(" In the course of reading, one’s attention is liable to shift, at an early stage, from the content of the positions argued for to the form the argument takes. One of the contributors rightly identifies the difficulty attending the discussion, which lies not so much in theological disagreement as in the fact that a given protagonist is prone to judge that the other misses the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("clear ")]), _vm._v("teaching of Scripture."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-18",
      "id": "footnote-1257-18-backlink"
    }
  }, [_vm._v("18")])]), _vm._v(" This contributor himself rejects classical Calvinism and Arminianism alike. He realizes that his interlocutors will take him, too, to be rejecting “clear” teaching, yet he cannot but express his own bewilderment at others’ doubt that he is representing “Paul’s clear, systematic and all-­pervasive teaching” on the heart of the matter at hand."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-19",
      "id": "footnote-1257-19-backlink"
    }
  }, [_vm._v("19")])]), _vm._v(" Nevertheless, he knows that others will be bewildered that he should be bewildered.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A reader’s attention may then shift a second time, this time to the tone. Contributors go beyond frequent expressions of astonishment that others cannot see what is clear, to very strong indictments of each other."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-20",
      "id": "footnote-1257-20-backlink"
    }
  }, [_vm._v("20")])]), _vm._v(" Not all are guilty of this; one is noticeably more restrained than the others. The upshot is that the North American evangelical scene alone gives pause for thought to anyone who proposes to sidle in coyly with what might be regarded as a sixth view — and, in counting, we have not begun to train our eyes outside this particular constituency. In the preface to his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Treatment concerning the Religious Affections, ")]), _vm._v("Jonathan Edwards observed: “I am sensible it is much more difficult to judge impartially of that which is the subject of this discourse, in the midst of the dust and smoke of such a state of controversy as this land is now in about things of this nature,” adding: “As it is more difficult to write impartially, so it is more difficult to read impartially.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-21",
      "id": "footnote-1257-21-backlink"
    }
  }, [_vm._v("21")])]), _vm._v(" If that is how it is when discussion is carried out amongst theologians who state unreserved commitment to the full authority of Scripture and make good that commitment by seeking to ground the essentials of their positions in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sola Scriptura, ")]), _vm._v("it is hard to know how one can make effective headway on the wider scene.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T1"
  }, [_vm._v("Of course, perhaps we just have to be tough-­minded and thick-­skinned about the whole affair. If you find the kitchen too hot, don’t go in. Why is it so hot? How should we interpret the intraevangelical dispute, not only in its own right, but for the benefit of the wider theological scene? Sticking with the volume cited, I think it is no exaggeration to say that, on the authors’ own terms, we have three or four rival versions of Christianity here. Is it basically an exegetical dispute? Obviously it is, in part. However, the disagreement cannot be analyzed simply in exegetical terms. The relevant exegetical exchanges remind me of the first football (soccer) match in which our second son proudly took part in an Oxfordshire village at the age of six. What was lacking in the quality of football was more than made good in the quality of entertainment. Apart from the two rival goalkeepers, who were dividing their attention between trying to figure out what exactly was going on in the midfield skirmish and musing absently on the Great Issues of Life, what you saw on the pitch was two groups of ten small children crowded around the ball, trying to kick it. As the ball cannoned off unpredictably in all directions, the two combatant formations scuttled around the pitch like a flock of seagulls at the seaside on a summer afternoon, competing for a coveted piece of bread. Just so, in exegetical debate, the battle moves on text by text, skirmish by skirmish. I am not for a moment demeaning or ridiculing the exegetical task or those who participate in it. That would be self-­defeating as well as impious because I regard the exegetical task as theologically foundational and should wish to participate in it, along with everybody else, though as one less qualified than many. However, what the lads in that game obviously needed was some order and structure to their play, and what we theologians need to engage in fruitful exegetical debate, particularly when trying to interpret a theme stretching over the whole of Scripture, is obviously some robust rules of engagement.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Are differences better identified and addressed at the level of hermeneutics? It is true that the wider hermeneutical task is foundational to the more narrowly exegetical task it frames. Yet, are differences any less intractable on the hermeneutical level than they are on the exegetical level? We should certainly profit from meticulously examining competing hermeneutical frameworks in both the age-­old and the contemporary debates over election. Whether we should end up with a less colorful and more controlled version, on the hermeneutical level, of the exegetical tussle, I am not sure. However, the intraevangelical debate is characterized by a feature that is more striking and more disturbing than hermeneutical differences, and this applies a fortiori to the wider debate. We have in mind divergences in the way in which God is understood and portrayed. This is disturbing even more than it is striking. Picture it: an experienced Christian steeps himself or herself in Scripture; strives for purity of heart and not just clarity of mind; prays, as well as studies, diligently. Then, in a theological essay emanating from the place of prayer and study, she or he depicts the face of God as it appears to be depicted on the Bible’s pages. Another theologian, no less experienced, steeped, striving, praying, and studying, does the same. They compare portraits. Not only are they vastly different. Each does not see how on earth the other can get that portrait out of Scripture. Worse: they do not like each other’s pictures at all. “It is a frightful child of a comely parent, with just enough family likeness to make one avert the face in dread,” said one commentator on the theology of Nathanael Emmons."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-22",
      "id": "footnote-1257-22-backlink"
    }
  }, [_vm._v("22")])]), _vm._v(" Multiply the number of theologians beyond two. It is not just that others’ portraits are deemed lacking in the quality of truthful representation. The flawed artist is deemed lacking in any sense of divine beauty. In a bleak moment, we might first succumb to an older translation of a Pauline text which represents us as seeing “through a glass, darkly” (1 Cor. 13:12) and then wonder whether Paul’s “enigma” (as the Greek has it) was ever supposed to license the production of a number of allegedly grotesque alternatives with which we must willingly put up in the church prior to the eschaton.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Keeping in mind Paul’s commendation of that charity with which he surrounds his reference to the “enigma,” we must surely be haunted by the question of whether we can all be worshiping the same God. If the face of Jesus Christ is the face of God, do we have not only one Jesus and many Christs, as Don Cupitt suggested long ago, but also many Jesuses?"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-23",
      "id": "footnote-1257-23-backlink"
    }
  }, [_vm._v("23")])]), _vm._v(" Borges wrote: “Diodorus Siculus tells the story of a god that is cut in pieces and scattered over the earth. Which of us, walking through the twilight . . . has never felt that we have lost some infinite thing. . . . Some feature of the crucified face may lurk in every mirror; perhaps the face died, faded away, so that God might be all faces . . . ?”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-24",
      "id": "footnote-1257-24-backlink"
    }
  }, [_vm._v("24")])]), _vm._v(" If these words dismay foes of theological or religious pluralism, its defenders will point out that it is better to conjure up a scene of dispersal than a specter of distortion. Is this not a more felicitous prospect than the prospect of mutual recrimination?"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('a', {
    staticClass: "_idFootnoteLink",
    attrs: {
      "href": "#/#footnote-1257-25",
      "id": "footnote-1257-25-backlink"
    }
  }, [_vm._v("25")])]), _vm._v(" Does postmodernity meet us at the end of the road, after all?")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For myself, I hope and believe not, and accordingly throw my hat in the ring. This volume started life as the Kantzer Lectures given at Trinity Evangelical Divinity School, Trinity International University, Deerfield, Illinois. Six lectures were delivered there in 2009, warts and all, but the material is now presented in a different order. As the lectures have been considerably expanded as well as revised for publication, there is doubtless an accumulation of warts, which I can only hope does not amount to a plague. The week spent in Deerfield giving the lectures was most pleasurable, and memories of the occasion, both on and off campus, in academic and nonacademic contexts, flood back in a merry tide, as this volume (finally!) goes to print. I received outstanding and warm hospitality from a number of people, but I want to thank two in particular. Kevin Vanhoozer chaired the lectures with his customary combination of graciousness and vivacity, exercising his ability both to restrain himself patiently and to offer the occasional and well-­judged provocative challenge. Doug Sweeney, then director of the Carl Henry Center, gave consistent support and encouragement, keeping himself in the background, as far as he was concerned, but moving swiftly to the foreground, as far as any help to the lecturer was concerned. Thanks, gentlemen, for your patience with the delay in producing this manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Above all, I must thank my wife, Susan, for her characteristic and unfailing support through the process of writing this book. It is only exegetical conscience which prevents me from dedicating this volume "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eklektē kuria kai tois teknois autēs, hous egō agapō en alētheia ")]), _vm._v("(2 John 1).")]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-1"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-1-backlink"
    }
  }, [_vm._v("1")]), _vm._v(". Unless otherwise indicated, quotations from the English Bible are from the New International Version (NIV).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-2"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-2-backlink"
    }
  }, [_vm._v("2")]), _vm._v(". Allan Janik and Stephen Toulmin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wittgenstein’s Vienna ")]), _vm._v("(New York: Simon and Schuster, 1973), p. 193.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-3"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-3-backlink"
    }
  }, [_vm._v("3")]), _vm._v(". As Barth’s thought is treated in detail in the appendix, detailed citation of his work is often reserved until then.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-4"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-4-backlink"
    }
  }, [_vm._v("4")]), _vm._v(". G. Marcel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Being and Having ")]), _vm._v("(Westminster: Dacre, 1949), pp. 110-16. In this work, Marcel observed that “we have acquired the execrable habit of considering the problems in themselves, i.e., in abstraction from the manner in which their appearance is woven into the very texture of life” (p. 102). Cf. T. Weinandy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Does God Suffer? ")]), _vm._v("(Edinburgh: T. & T. Clark, 2000), chap. 2.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-5"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-5-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". Paul K. Jewett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Election and Predestination ")]), _vm._v("(Grand Rapids: Eerdmans, 1985), p. 1.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-6"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-6-backlink"
    }
  }, [_vm._v("6")]), _vm._v(". G. C. Berkouwer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divine Election ")]), _vm._v("(Grand Rapids: Eerdmans, 1960), p. 7.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-7"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-7-backlink"
    }
  }, [_vm._v("7")]), _vm._v(". Chaucer, “The Nun’s Priest’s Tale,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Canterbury Tales ")]), _vm._v("(Harmondsworth and New York: Penguin, 1977), p. 243.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-8"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-8-backlink"
    }
  }, [_vm._v("8")]), _vm._v(". Ludwig Wittgenstein, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culture and Value, ")]), _vm._v("ed. G. H. von Wright (Oxford: Blackwell, 1980), p. 27.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-9"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-9-backlink"
    }
  }, [_vm._v("9")]), _vm._v(". Quoted by Mark Noll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("America’s God: From Jonathan Edwards to Abraham Lincoln ")]), _vm._v("(New York and Oxford: Oxford University Press, 2002), p. 327.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-10"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-10-backlink"
    }
  }, [_vm._v("10")]), _vm._v(". Elements in the argument set out in chapter 3 in connection with Simeon are anticipated in Stephen Williams, “Observations on the Future of System,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Always Reforming: Explorations in Systematic Theology, ")]), _vm._v("ed. A. T. B. McGowan (Leicester: Apollos, 2006), pp. 41-66. The other figure who occupies a significant place in that essay, G. C. Berkouwer, comes in for no sustained attention in the present volume. This is a bit puzzling; possibly the author of the present volume is taking small-­minded revenge on Berkouwer for ending, rather than starting, his book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divine Election ")]), _vm._v("with the Old Testament.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-11"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-11-backlink"
    }
  }, [_vm._v("11")]), _vm._v(". Christopher J. H. Wright, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mission of God: Unlocking the Bible’s Grand Narrative ")]), _vm._v("(Nottingham: Inter-­Varsity Press, 2006), p. 262.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-12"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-12-backlink"
    }
  }, [_vm._v("12")]), _vm._v(". Some readers will recognize here an adaptation of G. K. Chesterton’s words in his poem “The Donkey.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-13"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-13-backlink"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Far from the Madding Crowd ")]), _vm._v("(London and New York: Penguin, 1994), p. 250.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-14"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-14-backlink"
    }
  }, [_vm._v("14")]), _vm._v(". This is admittedly a rather pedantic rendering of “In der Beschränkung zeigt sich erst der Meister,” picked up from and quoted without attribution by P. T. Forsyth in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Person and Place of Jesus Christ ")]), _vm._v("(London: Hodder and Stoughton, 1909), p. 67, but found in Leibniz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophical Papers and Letters ")]), _vm._v("(Chicago: University of Chicago Press, 1969), p. 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-15"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-15-backlink"
    }
  }, [_vm._v("15")]), _vm._v(". Austin Farrer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faith and Speculation: An Essay in Philosophical Theology ")]), _vm._v("(Edinburgh: T. & T. Clark, 1967), p. vi.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-16"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-16-backlink"
    }
  }, [_vm._v("16")]), _vm._v(". Quoted in Alan C. Clifford, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Good Doctor: Philip Doddridge of Northampton; A Tercentenary Tribute ")]), _vm._v("(Norwich: Charenton Reformed Publishing, 2002), p. 133.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-17"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-17-backlink"
    }
  }, [_vm._v("17")]), _vm._v(". Chad Brand, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perspectives on Election: Five Views ")]), _vm._v("(Nashville: Broadman and Holman, 2006).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-18"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-18-backlink"
    }
  }, [_vm._v("18")]), _vm._v(". Brand, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perspectives on Election, ")]), _vm._v("p. 138.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-19"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-19-backlink"
    }
  }, [_vm._v("19")]), _vm._v(". Brand, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perspectives on Election, ")]), _vm._v("p. 142.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-20"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-20-backlink"
    }
  }, [_vm._v("20")]), _vm._v(". Far from regarding all this as a cause of consternation, the editor celebrates the exchange as an exciting theological banquet, a “treat.” Brand, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perspectives on Election, ")]), _vm._v("p. xi. I have deliberately refrained from naming names because that will only stoke up fires unnecessarily, but, of course, they are easily checked.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-21"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-21-backlink"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Works of Jonathan Edwards, ")]), _vm._v("vol. 2, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Religious Affections ")]), _vm._v("(New Haven: Yale University Press, 1959), p. 84.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-22"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-22-backlink"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Princeton Review ")]), _vm._v("14, no. 4 (October 1842): 69.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-23"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-23-backlink"
    }
  }, [_vm._v("23")]), _vm._v(". Don Cupitt, “One Jesus, Many Christs,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christ, Faith, and History: Cambridge Studies in Christology, ")]), _vm._v("ed. S. W. Sykes and J. P. Clayton (Cambridge: Cambridge University Press, 1972), pp. 131-44.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-24"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-24-backlink"
    }
  }, [_vm._v("24")]), _vm._v(". Jorge Luis Borges, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paradiso ")]), _vm._v("XXXI, 108,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Collected Fictions ")]), _vm._v("(New York: Penguin, 1999), p. 316.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-1257-25"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor",
    attrs: {
      "href": "#/#footnote-1257-25-backlink"
    }
  }, [_vm._v("25")]), _vm._v(". In this context, Borges’s reference to dismemberment may be compared with Arminius’s allusion over four centuries ago to a “young lady, mentioned by Plutarch, who was addressed by a number of suitors; and when each of them found that she could not become entirely his own, they divided her body into parts, and thus not one of them obtained possession of her whole person. This is the nature of discord, to disperse and destroy matters of greatest consequence.” “On Reconciling Religious Dissensions among Christians,” in Jacobus Arminius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Works, ")]), _vm._v("vol. 1 (London, 1825), p. 388.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b79daa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Williams_The_Election_of_Grace_text_CC-6.vue
// module id = 72
// module chunks = 0